var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 63,
    viewBox: "0 0 339 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.165 1.11647C196.997 1.11647 194.371 2.17258 192.259 4.25464C190.147 6.3367 189.091 8.96191 189.091 12.0699C189.091 15.1779 190.147 17.8031 192.259 19.8852C194.371 21.9672 196.997 23.0233 200.165 23.0233C202.398 23.0233 204.42 22.4802 206.2 21.3939C207.98 20.2774 209.338 18.7989 210.213 16.9582L205.566 15.2383C204.51 17.1996 202.549 18.4368 200.165 18.4368C198.445 18.4368 196.997 17.8333 195.82 16.6263C194.643 15.3891 194.07 13.8804 194.07 12.0699C194.07 10.2594 194.643 8.75068 195.82 7.54369C196.997 6.30653 198.445 5.70303 200.165 5.70303C202.549 5.70303 204.51 6.9402 205.566 8.90156L210.213 7.18159C209.338 5.34093 207.98 3.86237 206.2 2.77608C204.42 1.65961 202.428 1.11647 200.165 1.11647Z",
    fill: "url(#paint0_linear_59_25064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.259 22.6311H216.785V13.7597C216.785 12.0397 218.082 10.7422 219.772 10.7422C221.462 10.7422 222.759 12.0397 222.759 13.7597V22.6311H227.256V12.5527C227.256 10.8327 226.682 9.41453 225.505 8.26789C224.329 7.12125 222.91 6.54792 221.19 6.54792C219.35 6.54792 217.901 7.21177 216.785 8.53946V0H212.259V22.6311Z",
    fill: "url(#paint1_linear_59_25064)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.309 14.7856C229.309 17.1091 230.003 19.0705 231.421 20.6697C232.84 22.2388 234.62 23.0233 236.732 23.0233C238.361 23.0233 239.81 22.5405 241.077 21.5448V22.6311H245.573V6.9402H241.077V7.99631C239.78 7.03072 238.331 6.54792 236.732 6.54792C234.62 6.54792 232.84 7.33247 231.421 8.90156C230.003 10.4706 229.309 12.432 229.309 14.7856ZM237.517 11.0138C238.482 11.0138 239.297 11.3759 239.991 12.1001C240.685 12.8243 241.017 13.6993 241.017 14.7555C241.017 16.928 239.448 18.5575 237.517 18.5575C235.555 18.5575 234.016 16.928 234.016 14.7555C234.016 12.6734 235.555 11.0138 237.517 11.0138Z",
    fill: "url(#paint2_linear_59_25064)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.647 22.6311V0H248.121V22.6311H252.647Z",
    fill: "url(#paint3_linear_59_25064)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.719 22.6311V0H255.193V22.6311H259.719Z",
    fill: "url(#paint4_linear_59_25064)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.228 16.4151C278.348 15.9021 278.409 15.359 278.409 14.7856C278.409 12.4622 277.624 10.5008 276.025 8.93173C274.426 7.33247 272.464 6.54792 270.111 6.54792C267.727 6.54792 265.765 7.33247 264.166 8.93173C262.567 10.5008 261.782 12.4622 261.782 14.7856C261.782 17.1393 262.597 19.1006 264.226 20.6697C265.856 22.2388 267.908 23.0233 270.352 23.0233C273.701 23.0233 276.447 21.3939 277.865 18.7687L273.49 17.7729C272.706 18.7084 271.68 19.161 270.382 19.161C268.541 19.161 267.063 18.0747 266.55 16.4151H278.228ZM266.58 13.0657C267.093 11.4664 268.511 10.4103 270.111 10.4103C271.8 10.4103 273.219 11.4664 273.792 13.0657H266.58Z",
    fill: "url(#paint5_linear_59_25064)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M280.24 22.6311H284.767V13.7597C284.767 12.0397 286.004 10.7422 287.663 10.7422C289.323 10.7422 290.53 12.0397 290.53 13.7597V22.6311H295.056V12.5527C295.056 10.8327 294.483 9.41453 293.306 8.26789C292.159 7.12125 290.741 6.54792 289.051 6.54792C287.241 6.54792 285.823 7.21177 284.767 8.53946V6.9402H280.24V22.6311Z",
    fill: "url(#paint6_linear_59_25064)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297.114 14.7856C297.114 17.1091 297.808 19.0705 299.226 20.6697C300.644 22.2388 302.425 23.0233 304.537 23.0233C306.166 23.0233 307.615 22.5405 308.882 21.5448V22.3595C308.882 24.17 307.313 25.5279 305.352 25.5279C303.933 25.5279 302.666 24.8338 302.183 23.8682L297.717 24.9244C298.2 26.3426 299.166 27.4892 300.584 28.4246C302.032 29.36 303.662 29.8127 305.442 29.8127C307.705 29.8127 309.576 29.0885 311.085 27.6401C312.624 26.2219 313.378 24.4416 313.378 22.2992V6.9402H308.882V7.99631C307.585 7.03072 306.136 6.54792 304.537 6.54792C302.425 6.54792 300.644 7.33247 299.226 8.90156C297.808 10.4706 297.114 12.432 297.114 14.7856ZM305.321 11.0138C307.253 11.0138 308.822 12.6432 308.822 14.8158C308.822 15.8719 308.49 16.747 307.796 17.4712C307.102 18.1954 306.287 18.5575 305.321 18.5575C303.36 18.5575 301.821 16.8979 301.821 14.8158C301.821 12.6432 303.36 11.0138 305.321 11.0138Z",
    fill: "url(#paint7_linear_59_25064)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M331.888 16.4151C332.009 15.9021 332.069 15.359 332.069 14.7856C332.069 12.4622 331.284 10.5008 329.685 8.93173C328.086 7.33247 326.125 6.54792 323.771 6.54792C321.387 6.54792 319.426 7.33247 317.827 8.93173C316.227 10.5008 315.443 12.4622 315.443 14.7856C315.443 17.1393 316.257 19.1006 317.887 20.6697C319.516 22.2388 321.568 23.0233 324.012 23.0233C327.362 23.0233 330.108 21.3939 331.526 18.7687L327.15 17.7729C326.366 18.7084 325.34 19.161 324.042 19.161C322.202 19.161 320.723 18.0747 320.21 16.4151H331.888ZM320.24 13.0657C320.753 11.4664 322.172 10.4103 323.771 10.4103C325.461 10.4103 326.879 11.4664 327.452 13.0657H320.24Z",
    fill: "url(#paint8_linear_59_25064)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M336.405 17.8936C334.957 17.8936 333.871 18.9799 333.871 20.4585C333.871 21.9371 334.957 23.0233 336.405 23.0233C337.884 23.0233 339 21.9371 339 20.4585C339 18.9799 337.884 17.8936 336.405 17.8936ZM338.306 15.7512L338.849 1.50874H334.052L334.595 15.7512H338.306Z",
    fill: "url(#paint9_linear_59_25064)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.426 4.83494H171.612V11.1231H173.426V7.73719C173.426 6.99953 173.97 6.44327 174.696 6.44327C174.962 6.44327 175.18 6.50373 175.349 6.61257V4.67773C174.49 4.67773 173.849 4.94377 173.426 5.48795V4.83494Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.544 10.3371C164.185 10.9659 164.995 11.2803 165.951 11.2803C166.906 11.2803 167.704 10.9659 168.345 10.3371C168.986 9.69621 169.312 8.91018 169.312 7.97904C169.312 7.0479 168.986 6.26188 168.345 5.63306C167.704 4.99214 166.906 4.67773 165.951 4.67773C164.995 4.67773 164.185 4.99214 163.544 5.63306C162.903 6.26188 162.589 7.0479 162.589 7.97904C162.589 8.91018 162.903 9.69621 163.544 10.3371ZM165.951 9.49063C165.527 9.49063 165.177 9.34552 164.899 9.05529C164.62 8.76507 164.475 8.40229 164.475 7.97904C164.475 7.5558 164.62 7.19302 164.899 6.90279C165.177 6.61257 165.527 6.46745 165.951 6.46745C166.362 6.46745 166.712 6.61257 166.991 6.91488C167.281 7.20511 167.426 7.5558 167.426 7.97904C167.426 8.40229 167.281 8.75297 166.991 9.05529C166.712 9.34552 166.362 9.49063 165.951 9.49063Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.417 11.1232L156.409 7.80977L157.388 11.1232H159.033L161.028 4.83496H159.202L158.223 8.32975L157.231 4.83496H155.562L154.583 8.32975L153.603 4.83496H151.777L153.761 11.1232H155.417Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.649 6.40718H146.508V9.11595C146.508 9.68431 146.714 10.168 147.137 10.555C147.56 10.9299 148.092 11.1233 148.709 11.1233H149.749V9.43036H149.011C148.612 9.43036 148.322 9.15223 148.322 8.76526V6.40718H149.749V4.83513H148.322V3.61377H146.508V4.83513H145.649V6.40718Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.461 11.1231H130.275V7.56789C130.275 6.87861 130.771 6.35862 131.436 6.35862C132.101 6.35862 132.585 6.87861 132.585 7.56789V11.1231H134.398V7.08418C134.398 6.3949 134.169 5.82654 133.697 5.36702C133.238 4.9075 132.669 4.67773 131.992 4.67773C131.266 4.67773 130.698 4.94377 130.275 5.47585V4.83494H128.461V11.1231Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.449 7.976C143.449 8.20599 143.425 8.42388 143.377 8.62966H138.735C138.939 9.29543 139.527 9.7312 140.258 9.7312C140.565 9.7312 140.79 9.64892 140.988 9.50348L142.156 10.6814C141.604 11.1608 141.096 11.2806 140.246 11.2806C139.275 11.2806 138.459 10.9659 137.811 10.3364C137.164 9.70699 136.84 8.92018 136.84 7.976C136.84 7.04393 137.152 6.25712 137.787 5.62767C138.423 4.98611 139.203 4.67139 140.15 4.67139C141.086 4.67139 141.866 4.98611 142.501 5.62767C143.137 6.25712 143.449 7.04393 143.449 7.976ZM140.15 6.2208C139.515 6.2208 138.951 6.64447 138.747 7.28603H141.614C141.386 6.64447 140.822 6.2208 140.15 6.2208Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.301 11.1232H179.115V8.42656L181.086 11.1232H183.262L180.856 7.8703L183.033 4.83503H180.892L179.115 7.30194V2.05371H177.301V11.1232Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69841 20.0163L17.4267 20.0163L17.4348 20.0082H30.0326L13.1569 36.884C11.9696 38.0712 11.736 39.0881 11.7528 39.7784C11.7715 40.5493 12.1169 41.3577 12.7622 42.0031C13.4076 42.6486 14.2159 42.994 14.9866 43.0128C15.6766 43.0296 16.693 42.7962 17.8796 41.6096L36.7771 22.7122C39.5273 19.9619 42.8415 18.6202 46.1869 18.7017C49.4517 18.7813 52.3833 20.2077 54.4935 22.3183C56.6037 24.4289 58.0295 27.3606 58.1089 30.625C58.1903 33.9701 56.8491 37.2841 54.0991 40.0342L43.4178 50.7154H30.82L47.8002 33.7353C48.9868 32.5487 49.2204 31.5321 49.2036 30.8417C49.1848 30.0706 48.8394 29.2621 48.194 28.6166C47.5487 27.9712 46.7405 27.6259 45.9699 27.6071C45.28 27.5903 44.2633 27.8237 43.076 29.0111L24.1785 47.9085C21.4285 50.6586 18.1144 51.9998 14.7692 51.9181C11.5048 51.8385 8.57321 50.4122 6.46297 48.3017C4.35272 46.1912 2.92673 43.2594 2.84739 39.9948C2.76609 36.6494 4.10768 33.3353 6.85794 30.5851L10.7457 26.6973L0 26.6973L6.69841 20.0163Z",
    fill: "url(#paint10_linear_59_25064)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2874 50.7152H81.8857C81.9482 50.4916 81.9807 50.2596 81.9807 50.0205C81.9807 49.2537 81.6268 48.6048 80.919 48.015C79.5624 46.8353 78.1468 46.3635 75.7875 45.5967L75.1976 45.4197C74.7454 45.2821 74.326 45.151 73.9415 45.0309C73.1725 44.7906 72.5434 44.594 72.0715 44.476L69.1813 43.4143C67.9427 42.8834 66.9989 42.4706 66.3501 42.0577C66.2765 42.0051 66.2 41.9507 66.1211 41.8945C64.8704 41.0046 62.9945 39.6697 62.1623 38.2827C61.2775 36.8081 60.5107 34.6847 60.5107 32.2664C60.5107 28.4915 61.8084 25.4243 64.4037 23.124C67.0579 20.7646 70.479 19.585 74.6668 19.585C78.3827 19.585 81.6268 20.5287 84.3401 22.3572C87.1123 24.1857 88.8228 26.486 89.5896 29.2583L80.3292 31.4406C79.7983 29.6122 77.616 28.1966 74.8437 28.1966C72.0125 28.1966 69.8891 29.6122 69.8891 31.5586C69.8891 32.7973 71.0098 33.918 73.3102 34.8617C74.1359 35.1566 76.2004 35.8054 79.5034 36.8081C82.0397 37.5749 83.3374 37.9878 85.6967 39.4034C89.1177 41.2319 91.1232 44.1221 91.3591 49.1947C91.3591 49.7154 91.3353 50.2222 91.2874 50.7152Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1572 50.7152H103.005V37.5618L112.619 50.7152H123.236L111.498 34.8486L122.115 20.0437H111.675L103.005 32.0764V6.47754H94.1572V50.7152Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.019 35.2045C153.019 36.3252 152.901 37.3869 152.666 38.3897H129.839C130.842 41.6338 133.732 43.7572 137.33 43.7572C138.836 43.7572 139.945 43.3562 140.919 42.6475L146.659 48.387C143.947 50.7232 141.449 51.307 137.271 51.307C132.493 51.307 128.482 49.7735 125.297 46.7063C122.112 43.6392 120.52 39.8053 120.52 35.2045C120.52 30.6628 122.053 26.8289 125.179 23.7617C128.305 20.6356 132.139 19.1021 136.799 19.1021C141.4 19.1021 145.234 20.6356 148.36 23.7617C151.486 26.8289 153.019 30.6628 153.019 35.2045ZM136.799 26.6519C133.673 26.6519 130.901 28.7164 129.898 31.8425H143.995C142.874 28.7164 140.102 26.6519 136.799 26.6519Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.485 55.5525C159.319 55.5525 161.737 54.0189 162.858 50.9518L163.035 50.4799L151.415 20.0444H160.557L167.223 38.9781L174.124 20.0444H183.266L170.231 53.901C168.403 58.4702 165.912 61.3434 162.344 62.8061L155.09 55.5525H155.485Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_25064",
    x1: 339,
    y1: 28.1607,
    x2: 193.001,
    y2: 26.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_25064",
    x1: 58.1124,
    y1: 50.0807,
    x2: 1.50637,
    y2: 49.8107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446418,
    stopColor: "#5C44EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5DEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7738fe16.svg";
export { ForwardRef as ReactComponent };